import { render } from "./dialogV2.vue?vue&type=template&id=49e3d3dc&scoped=true"
import script from "./dialogV2.vue?vue&type=script&lang=ts"
export * from "./dialogV2.vue?vue&type=script&lang=ts"

import "./dialogV2.vue?vue&type=style&index=0&id=49e3d3dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-49e3d3dc"

export default script